import React, { useState } from 'react';
import axios from 'axios';

const API = 'https://tribaltech-backend.onrender.com';

export default function VaultLogin() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | sent | error
  const [err, setErr]   = useState('');

  async function submit(e) {
    e.preventDefault();
    if (!email) return;
    setState('sending'); setErr('');
    try {
      await axios.post(`${API}/api/vault/request-login`, { email });
      setState('sent');
    } catch (e) {
      setErr(e.response?.data?.error || e.message);
      setState('error');
    }
  }

  return (
    <div style={page}>
      <div style={card}>
        <div style={eyebrow}>Creator Protect · Vault</div>
        <h1 style={{ color:'#fff', fontSize: 26, margin:'6px 0 18px' }}>Your purchases, in one place</h1>
        <p style={{ color:'#94a3b8', lineHeight: 1.6, marginBottom: 24 }}>
          Enter the email you used at checkout. We'll send you a sign-in link — no password, no account setup.
        </p>

        {state === 'sent' ? (
          <div style={{ padding: 16, background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.3)', borderRadius: 8, color:'#4ade80' }}>
            Check <strong>{email}</strong>. If we have any purchases on that address, the link is on its way (it expires in 15 minutes).
          </div>
        ) : (
          <form onSubmit={submit}>
            <label style={label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              disabled={state === 'sending'}
              required
              style={input}
            />
            <button type="submit" disabled={state === 'sending' || !email} style={button}>
              {state === 'sending' ? 'Sending…' : 'Email me a sign-in link'}
            </button>
            {err && <div style={{ color:'#f87171', fontSize: 13, marginTop: 12 }}>{err}</div>}
          </form>
        )}

        <div style={{ marginTop: 24, fontSize: 11, color:'#555', textAlign:'center' }}>
          Secured by Creator Protect · creatorprotect.io
        </div>
      </div>
    </div>
  );
}

const page = {
  minHeight:'100vh',
  background:'linear-gradient(180deg, #0f0f1e 0%, #0a0a0f 100%)',
  display:'flex', alignItems:'center', justifyContent:'center',
  padding:'40px 20px',
};
const card = {
  background:'#111', borderRadius: 16, padding: 32,
  maxWidth: 480, width:'100%',
  border:'1px solid #222',
  boxShadow:'0 20px 60px rgba(0,0,0,0.5)',
};
const eyebrow = { fontSize: 11, color:'#888', letterSpacing: 2, textTransform:'uppercase', marginBottom: 6 };
const label   = { display:'block', fontSize: 12, color:'#94a3b8', marginBottom: 6 };
const input   = {
  width:'100%', padding: 12, borderRadius: 8,
  background:'#0a0a0a', border:'1px solid #222',
  color:'#fff', fontSize: 14, boxSizing:'border-box', marginBottom: 14,
};
const button  = {
  width:'100%', padding: 14, borderRadius: 8, border:'none',
  background:'#7c3aed', color:'#fff', fontSize: 15, fontWeight: 600, cursor:'pointer',
};
